import {
    LuFolder,
    LuFile,
    LuTrash2,
    LuVideo,
    LuImage,
    LuFileText,
    LuChevronUp,
    LuChevronDown
} from "react-icons/lu";
import { useNavigate, useParams } from "react-router-dom";
import TableInnerRowsLoading from "../Loaders/TableInnerRowsLoading";
import { BiDownload } from "react-icons/bi";
import { TbFileSad, TbLock } from "react-icons/tb";
import { useLayoutEffect, useRef, useState } from "react";
import FormatDateTime from "../Functions/FormatDate";
import { IoOpenOutline } from "react-icons/io5";

const WorkflowsTable = ({
    loading,
    data,
    setSelectedItem,
    setShowDeleteItem,
    downloadItem,
    orgData
}) => {
    const navigate = useNavigate();
    const { org_id } = useParams()

    const headers = [
        "name",
        "description",
        "trigger type",
        "status",
        "created at",
        "actions"

    ]

    return (
        <div className="custom_table_container fade-in">
            <table className="custom_table">
                <thead className="custom_table_head">
                    <tr className="custom_table_row">
                        {headers.map((header, index) => (
                            <th key={index} className="custom_table_th">
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody className="custom_table_body">
                    {loading ? (
                        <TableInnerRowsLoading />
                    ) : (
                        data.length > 0 ? (
                            data.map((item, rowIndex) => (
                                <tr key={item.id || rowIndex} className="custom_table_row">

                                    <td className="custom_table_td td_name" title={`Open workflow ${item.name}`} onClick={()=> navigate(`/e8console/organizations/${org_id}/workflows/${item.id}`)}>
                                            <IoOpenOutline/>
                                            {item.name}
                                    </td>
                                    <td className="custom_table_td ">
                                        <span className="td_desc">
                                            {item.description}
                                        </span>
                                    </td>
                                    <td className="custom_table_td">
                                        {item.trigger_type || "-"}
                                    </td>

                                    <td className="custom_table_td td_status">
                                        <div className="custom_cell_status">
                                            {item.is_active ? (
                                                <span className="status_dot active" title="Uploaded correctly"></span>
                                            ) : (
                                                <span className="status_dot error " title="Not uploaded - error"></span>
                                            )}
                                        </div>
                                    </td>

                                    <td className="custom_table_td">
                                        {FormatDateTime(item.created_at)}
                                    </td>

                                    <td className="custom_table_td td_actions">
                                        <button
                                            className="remove_file_btn"
                                            onClick={() => { setShowDeleteItem(true); setSelectedItem(item) }}
                                            title="Delete"
                                        >
                                            <LuTrash2 />
                                        </button>
                                        {item.type === "file" && (
                                            <button
                                                className="remove_file_btn"
                                                onClick={() => downloadItem(item)}
                                                title="Download file"
                                            >
                                                <BiDownload />
                                            </button>
                                        )}
                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr className="custom_table_row_empty">
                                <td colSpan={headers.length} className="custom_table_td_empty ">
                                    <div className="custom_table_td_empty_inner fade-in">
                                        <i> <TbFileSad /></i>
                                        No data found...
                                    </div>
                                </td>
                            </tr>
                        )
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default WorkflowsTable;